
import { Form, Field } from 'react-final-form'

import styles from './styles.module.scss'

import fileUploadIcon from '../../assets/file-upload.svg'
import { Candidato } from '../../types/Candidato'
import { schema } from './schema'
import { validate } from '../../utils/validate'
import createDecorator from 'final-form-focus';
import { format } from '../../utils/form';
import { useState } from 'react'
import { TermosDeUsoModal } from '../TermosDeUsoModal'

const focusOnErrors = createDecorator();

interface OnSubmitPropsValues {
  candidato: Candidato;
  curriculo: File;
}
interface FormCurriculoProps {
  candidato: Candidato;
  onSubmit: (values: OnSubmitPropsValues) => void;
}
export function FormCurriculo({ candidato, onSubmit }: FormCurriculoProps) {
  const [isTermosDeUsoModalOpen, setIsTermosDeUsoModalOpen] = useState(false)
  const [dadosCandidato, setDadosCandidato] = useState(null)
  const CPF_MASK = 'XXX.XXX.XXX-XX';
  const TELEFONE_MASK = '(XX) XXXXX-XXXX'

  function handleCloseTermoDeUsoModal() {
    setIsTermosDeUsoModalOpen(false)
  }

  async function handleSubmitCurriculo(values: any) {
    setDadosCandidato({ candidato: values as Candidato, curriculo: values.curriculo })
    setIsTermosDeUsoModalOpen(true)
  }

  return (
    <>
      <Form
        initialValues={{
          ...candidato
        }}
        onSubmit={handleSubmitCurriculo}
        validate={validate(schema)}
        decorators={[focusOnErrors]}
        render={({ handleSubmit }) => (
          <form
            className={styles.form}
            onSubmit={handleSubmit}
            noValidate>

            <Field name="telefone" component="input" {...format(TELEFONE_MASK)}>
              {({ input, meta }) => {
                const temErro = meta.error && meta.touched
                const classNameError = temErro ? styles.input_error : ''
                return (
                  <div>
                    <label htmlFor="telefone">Telefone</label>
                    <input {...input} className={classNameError} type="text" id="telefone" placeholder="(__) ____-____" />
                    {temErro && <span className={styles.mensagem_erro}>{meta.error}</span>}
                  </div>
                )
              }}
            </Field>

            <Field name="cpf" component="input" {...format(CPF_MASK)}>
              {({ input, meta }) => {
                const temErro = meta.error && meta.touched
                const classNameError = temErro ? styles.input_error : ''
                return (
                  <div>
                    <label htmlFor="cpf">CPF</label>
                    <input {...input} className={classNameError} type="text" id="cpf" placeholder="___.___.__" />
                    {temErro && <span className={styles.mensagem_erro}>{meta.error}</span>}
                  </div>
                )
              }}
            </Field>

            <Field name="departamento" component="select">
              {({ input, meta }) => {
                const temErro = meta.error && meta.touched
                const classNameError = temErro ? styles.input_error : ''
                return (
                  <div>
                    <label htmlFor="departamento">Departamento</label><br/>
                    <select {...input} className={classNameError} id="departamento">
                      <option value="">Selecione o departamento desejado</option>
                      <option value="Administrativo">Administrativo</option>
                      <option value="Cobranca - Operacao">Cobrança - Operação</option>
                      <option value="Cobranca - Gestao">Cobrança - Gestão</option>
                      <option value="Financeiro">Financeiro</option>
                      <option value="Juridico">Jurídico</option>
                      <option value="Gestao de Pessoas">Gestão de Pessoas</option>
                      <option value="Planejamento e Estrategia">Planejamento e Estratégia</option>
                      <option value="Qualidade">Qualidade</option>
                      <option value="T.I">T.I</option>
                    </select>
                    {temErro && <span className={styles.mensagem_erro}>{meta.error}</span>}
                  </div>
                )
              }}
            </Field>

            <Field name="curriculo" component="input">
              {({ input: { value, onChange, ...input }, meta }) => {
                const temError = meta.error && meta.touched
                const classNameError = temError ? styles.file_error : ''
                return (
                  <div
                    className={styles.curriculo}>
                    <label className={classNameError}>
                      <input
                        {...input}
                        type="file"
                        accept=".doc,.docx,.pdf"
                        onChange={({ target }) => onChange(target.files[0])}
                      />
                      <img src={fileUploadIcon} alt="Icone upload de arquivos" />
                    </label>

                    {temError
                      ? (<span className={styles.mensagem_erro}>{meta.error}</span>)
                      : (<p> {value ? value.name : 'Envie seu currículo!'} </p>)
                    }
                  </div>
                )
              }
              }
            </Field>

            <button
              type="submit"
              className={styles.btn_principal}>
              Se candidatar!
            </button>
          </form>
        )}
      />

      <TermosDeUsoModal
        isOpen={isTermosDeUsoModalOpen}
        onRequestClose={handleCloseTermoDeUsoModal}
        onAcept={() => {
          handleCloseTermoDeUsoModal()
          onSubmit(dadosCandidato)
        }} />
    </>
  )
}